import { useEffect, useMemo, useState } from 'react';
import { IOrganization } from '@vivli/features/organizations/infrastructure/interface';
import { useOrganizationsApiContext } from '@vivli/core/infrastructure/context';

export function useOrganizations() {
    const [organizations, setOrganizations] = useState<IOrganization[]>();
    const [isLoadingOrganizations, setIsLoadingOrganizations] = useState(false);

    const orgsApi = useOrganizationsApiContext();

    useEffect(() => {
        setIsLoadingOrganizations(true);

        const subscription = orgsApi.getOrganizations().subscribe({
            next: (orgs) => {
                if (orgs !== null) {
                    setOrganizations(orgs);
                    setIsLoadingOrganizations(false);
                }
            },
            error: () => {
                setIsLoadingOrganizations(false);
            },
        });

        return () => {
            subscription.unsubscribe();
        };
    }, []);

    const irpApproverOrgs = useMemo(() => organizations?.filter((org) => org.isIRPApprover) ?? null, [organizations]);

    const qaReviewerOrgs = useMemo(() => organizations?.filter((org) => org.isQaReviewer) ?? null, [organizations]);

    const annotatorOrgs = useMemo(() => organizations?.filter((org) => org.isAnnotator) ?? null, [organizations]);

    return {
        organizations,
        isLoadingOrganizations,
        irpApproverOrgs,
        qaReviewerOrgs,
        annotatorOrgs,
    };
}
